import { X12CharacterSet } from './x12-character-set';
import { EdifactSegmentSuffix } from './edifact-segment-suffix';
import { X12SecurityQualifier } from './x12-security-qualifier';
import { X12AuthorizationQualifier } from './x12-authorization-qualifier';
import { PartnerIdentificationType } from './partner-identification-type';

export class X12Config {
    X12ConfigId: number;
    AuthorizationQualifier: X12AuthorizationQualifier;
    CharacterSet: X12CharacterSet;
    SecurityQualifier: X12SecurityQualifier;
    EdifactSegmentSuffix: EdifactSegmentSuffix;
    AuthorizationValue?: string;
    SecurityValue?: string;
    ComponentElementSeparator: string;
    DataElement: string;
    SegmentTerminator?: string;
    ReplacementCharacter: string;
    PartnerIdentificationType: PartnerIdentificationType;
    Qualifier: string;
}